const pageHeroSection = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const btn = document.querySelector('.page-hero__scroll-down');

        if (!btn) return;

        btn.addEventListener('click', function (e) {
            e.preventDefault();

            window.scrollTo({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        });
    });
};

export default pageHeroSection;
